import { Button } from "@material-ui/core";
import React from "react";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import SingleSelectNew from "../../../components/SelectField/SingleSelectNew";
import { CommonConfirmationDialog } from "../../../components/DialogComponent/SupplyDataDialog";

const SupplyCategorysDetails = ({ supplyCategoryPros }) => {

    const [deleteDialog, setDeleteDialog] = React.useState(false);
    const [deleteSupplyListDialog, setDeleteSupplyListDialog] = React.useState(false);
    const [temptSupply, setTemptSupply] = React.useState(null);
    const [temptCategory, setTemptCategory] = React.useState(null);
  
  const {
    styles,
    isMobile,
    handleRemoveCategory,
    handleRemoveItem,
    getCategoryItems,
    parentCategories,
    handleAddCategory,
    handleAddItem,
    newCategory,
    setNewCategory,
    newItem,
    setNewItem,
    handleSaveEdit,
    setEditItem,
    editItem,
  } = supplyCategoryPros;



  const handleDeleteCofirm = () => {
    handleRemoveItem(temptSupply?.id);
    setDeleteDialog(false);
    setTemptSupply(null);
  }

  const handleDeleteClose = () => {
    setDeleteDialog(false);
    setTemptSupply(null);
  }

  const handleDeleteServiceListCofirm = () => {
    handleRemoveCategory(temptCategory?.id);
    setDeleteSupplyListDialog(false);
    setTemptCategory(null);
  }

  const handleDeleteTaskListClose = () => {
    setDeleteSupplyListDialog(false);
    setTemptCategory(null);
  }

  const handleInputChange = (e, categoryId, OrderPeriod = false) => {
    if (OrderPeriod === true) {
      setNewItem((prev) => ({
        ...prev,
        [categoryId]: {
          ...prev[categoryId],
          OrderPeriod: e,
        },
      }));
    } else {
      const { name, value } = e.target;
      setNewItem((prev) => ({
        ...prev,
        [categoryId]: {
          ...prev[categoryId],
          [name]: value,
        },
      }));
    }
  };

  const handleEditClick = (item, categoryId) => {
    setEditItem({
      categoryId,
      itemId: item.id,
      title: item.title,
      description: item.description,
      maxNumberAllowed: item.maxNumberAllowed || "",
      OrderPeriod: item.OrderPeriod || "",
    });
  };

  const orderPeriodOption = [
    { label: "Monthly", value: "Monthly" },
    { label: "Quarterly", value: "Quarterly" },
    { label: "Semi-Annual", value: "Semi-Annual" },
  ];

  return (
    <>
      <div className={styles.supplyContainer}>
        <div
          className={
            isMobile
              ? "d-flex flex-direction-column mv-30 w-100 bg-white  dark:bg-[#1A1F2C] dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] border-[1px] border-[hsl(214.3,31.8%,91.4%)] dark:border-[#2A2F3C]"
              : "mv-30 w-100  dark:bg-[#1A1F2C]  dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] border-[1px] border-[hsl(214.3,31.8%,91.4%)] dark:border-[#2A2F3C]"
          }
          style={{
            borderRadius: "8px",
            padding: "16px",
          }}
        >
          <div className={`${styles.label} mb-10 dark:text-white`}>
            Add New Category
          </div>
          <div
            className={
              isMobile
                ? `d-flex mt-10 ${styles.selectWidth}`
                : `d-flex flex-center w-35`
            }
          >
            <input
              type="text"
              value={newCategory}
              onChange={(e) => setNewCategory(e.target.value)}
              placeholder="Enter category name"
              className={`${styles.textInput} mr-10 dark:bg-[#0F1729] dark:text-white`}
            />
            <Button
              onClick={handleAddCategory}
              className={
                !newCategory
                  ? `${styles.btn} ${styles.btnPrimaryDisabled}`
                  : `${styles.btn} ${styles.btnPrimary}`
              }
              disabled={!newCategory}
            >
              <AddIcon /> Add Category
            </Button>
          </div>
        </div>

        <div className={styles.categoriesList}>
          {parentCategories
            ?.filter((category) => !category.deleted)
            ?.map((category) => (
              <div
                key={category.id}
                className={`${styles.categoryCard} dark:bg-[#1A1F2C] dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] dark:border-0`}
              >
                <div
                  className={`${styles.categoryHeader} dark:bg-[#1A1F2C] dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]`}
                >
                  <h2
                    className="dark:text-white"
                    style={{
                      fontSize: "18px",
                      fontWeight: "600",
                    }}
                  >
                    {category.orders}. {category.title}
                  </h2>
                  <Button
                    variant="contained"
                    onClick={() => {
                      setDeleteSupplyListDialog(true);
                      setTemptCategory(category);
                    }}
                    className={`${styles.btnIcon2} ${styles.delete}`}
                  >
                    Remove
                  </Button>
                </div>

                <div className={styles.itemsList}>
                  <div className={styles.inputGroup}>
                    <div
                      className={
                        isMobile ? "d-flex flex-direction-column" : "d-flex"
                      }
                      style={{ width: "90%" }}
                    >
                      <input
                        type="text"
                        name="title"
                        placeholder="Item Name"
                        value={
                          editItem?.categoryId === category.id
                            ? editItem.title
                            : newItem[category.id]?.title || ""
                        }
                        onChange={(e) => {
                          if (editItem?.categoryId === category.id) {
                            setEditItem({ ...editItem, title: e.target.value });
                          } else {
                            handleInputChange(e, category.id);
                          }
                        }}
                        className={`${styles.textInput} dark:bg-[#0F1729] dark:text-white`}
                      />
                      <input
                        type="text"
                        name="description"
                        placeholder="Description"
                        value={
                          editItem?.categoryId === category.id
                            ? editItem.description
                            : newItem[category.id]?.description || ""
                        }
                        onChange={(e) => {
                          if (editItem?.categoryId === category.id) {
                            setEditItem({
                              ...editItem,
                              description: e.target.value,
                            });
                          } else {
                            handleInputChange(e, category.id);
                          }
                        }}
                        className={
                          isMobile
                            ? `${styles.textInput} mt-10 dark:bg-[#0F1729] dark:text-white`
                            : `${styles.textInput} ml-10 dark:bg-[#0F1729] dark:text-white `
                        }
                      />
                      {category.title === "Company Clothing" && (
                        <>
                          <input
                            type="number"
                            name="maxNumberAllowed"
                            placeholder="Max Number Allowed"
                            value={
                              editItem?.categoryId === category.id
                                ? editItem.maxNumberAllowed
                                : newItem[category.id]?.maxNumberAllowed || ""
                            }
                            onChange={(e) => {
                              if (editItem?.categoryId === category.id) {
                                setEditItem({
                                  ...editItem,
                                  maxNumberAllowed: e.target.value,
                                });
                              } else {
                                handleInputChange(e, category.id);
                              }
                            }}
                            className={
                              isMobile
                                ? `${styles.textInput} mt-10 dark:bg-[#0F1729] dark:text-white`
                                : `${styles.textInput} ml-10 dark:bg-[#0F1729] dark:text-white`
                            }
                          />
                          <div
                            className={
                              isMobile
                                ? `${styles.orderSelect} mt-10`
                                : `${styles.orderSelect} ml-10`
                            }
                          >
                            <SingleSelectNew
                              contentClass="bg-white text-black border-gray-300 dark:bg-[#2c3440] dark:text-white dark:border-[#464c59]"
                              itemClass="hover:bg-gray-100 dark:hover:bg-[#3c4351]"
                              name="OrderPeriod"
                              label="OrderPeriod"
                              placeholder="OrderPeriod"
                              value={
                                editItem?.categoryId === category.id
                                  ? editItem.OrderPeriod
                                  : newItem[category.id]?.OrderPeriod || ""
                              }
                              onChange={(e) => {
                                if (editItem?.categoryId === category.id) {
                                  setEditItem({
                                    ...editItem,
                                    OrderPeriod: e,
                                  });
                                } else {
                                  handleInputChange(e, category.id, true);
                                }
                              }}
                              options={orderPeriodOption}
                            />
                          </div>
                        </>
                      )}
                    </div>
                    <div className={isMobile ? "w-100" : ""}>
                      {editItem?.categoryId === category.id ? (
                        <Button
                          onClick={() => handleSaveEdit(category.id)}
                          className={`${styles.btn} ${styles.btnSuccess}`}
                        >
                          <AddIcon /> Save Item
                        </Button>
                      ) : (
                        <Button
                          onClick={() => handleAddItem(category.id)}
                          className={
                            !newItem[category.id]?.title
                              ? `${styles.btn} ${styles.btnSuccessDisabled}`
                              : `${styles.btn} ${styles.btnSuccess}`
                          }
                          disabled={!newItem[category.id]?.title}
                        >
                          <AddIcon /> Add Item
                        </Button>
                      )}
                    </div>
                  </div>

                  {getCategoryItems(category.id)?.map((item, index) =>
                    isMobile ? (
                      <div key={item.id} className={styles.itemCard}>
                        <div className={styles.itemHeader}>
                          <h3 className="text-[#020817] dark:text-white">
                            {index + 1}. {item.title}
                          </h3>
                          <div className={styles.itemActions}>
                            <Button
                              onClick={() => handleEditClick(item, category.id)}
                              className={styles.editBtn}
                            >
                              <EditIcon
                                fontSize="small"
                                className={styles.editIcons}
                              />
                            </Button>
                            <Button
                              onClick={() => {
                                setDeleteDialog(true);
                                setTemptSupply(item);
                              }}
                              className={styles.deleteBtn}
                            >
                              <DeleteIcon fontSize="small" />
                            </Button>
                          </div>
                        </div>
                        <div>
                          {item.description && (
                            <p className={styles.itemDescription}>
                              {item.description}
                            </p>
                          )}

                          {category.title.toLowerCase() ===
                            "company clothing" && (
                            <>
                              {item.maxNumberAllowed && (
                                <p className={styles.itemDescription}>
                                  {item.maxNumberAllowed}
                                </p>
                              )}
                              {item.OrderPeriod && (
                                <p className={styles.itemDescription}>
                                  {item.OrderPeriod}
                                </p>
                              )}
                            </>
                          )}
                        </div>
                      </div>
                    ) : (
                      <div
                        key={item.id}
                        className={`${styles.itemCard} dark:border-0`}
                      >
                        <div className={styles.itemHeader}>
                          <h3 className="text-[#020817] dark:text-white">
                            {index + 1}. {item.title}
                          </h3>

                          {item.description && (
                            <p className={styles.itemDescription}>
                              {item.description}
                            </p>
                          )}

                          {category.title.toLowerCase() ===
                            "company clothing" && (
                            <>
                              {item.maxNumberAllowed && (
                                <p className={styles.itemDescription}>
                                  {item.maxNumberAllowed}
                                </p>
                              )}
                              {item.OrderPeriod && (
                                <p className={styles.itemDescription}>
                                  {item.OrderPeriod}
                                </p>
                              )}
                            </>
                          )}
                          <div className={styles.itemActions}>
                            <Button
                              onClick={() => handleEditClick(item, category.id)}
                              className={styles.editBtn}
                            >
                              <EditIcon
                                fontSize="small"
                                className={styles.editIcons}
                              />
                            </Button>
                            <Button
                              onClick={() => {
                                setDeleteDialog(true);
                                setTemptSupply(item);
                              }}
                              className={styles.deleteBtn}
                            >
                              <DeleteIcon fontSize="small" />
                            </Button>
                          </div>
                        </div>
                      </div>
                    )
                  )}
                </div>
              </div>
            ))}
        </div>
      </div>
      {deleteDialog && (
        <CommonConfirmationDialog
          open={deleteDialog}
          onConfirm={handleDeleteCofirm}
          onClose={handleDeleteClose}
          title={"Supply Delete"}
          message={"Are you sure you want to delete the supply?"}
          buttonTitle={"Yes"}
        />
      )}
      {deleteSupplyListDialog && (
        <CommonConfirmationDialog
          open={deleteSupplyListDialog}
          onConfirm={handleDeleteServiceListCofirm}
          onClose={handleDeleteTaskListClose}
          title={"Supply Category Delete"}
          message={
            "Are you sure you want to delete this supply category and all associated supplies??"
          }
          buttonTitle={"Yes"}
        />
      )}
    </>
  );
};

export default SupplyCategorysDetails;
